import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

type ThemeMode = "light" | "dark";
interface IState {
    mode: ThemeMode;
}
const initialMode: ThemeMode = "light";
const initialState: IState = { mode: initialMode };

const themeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        setThemeMode(state: IState, action: PayloadAction<ThemeMode>) {
            const themeMode = action.payload;
            state.mode = themeMode;
        },
        toggleThemeMode(state: IState) {
            state.mode = state.mode === "light" ? "dark" : "light";
        },
    },
});

export const { setThemeMode, toggleThemeMode } = themeSlice.actions;

export default themeSlice.reducer;
